import React, { useState } from 'react';
import { EyeShowIcon, EyeHideIcon } from '@rsos/assets/icons';
import { Button, Box, Text } from '@rsos/components/capstone/base';
import {
  MaskContainer,
  MaskedText,
  TextContainer,
} from './MaskVisibility.styles';

const MaskVisibility = ({ text }) => {
  const [isTextVisible, setIsTextVisible] = useState(false);

  const toggleVisibility = () => {
    setIsTextVisible(prev => !prev);
  };

  const ensureSafeText = text => {
    if (typeof text !== 'string') {
      return '';
    }
    return text;
  };
  const safeText = ensureSafeText(text);

  return (
    <Box horizontal flow={3} width="100%">
      <Button
        btnType="tertiary"
        size="xsmall"
        onClick={toggleVisibility}
        noMargin
      >
        {isTextVisible ? (
          <EyeHideIcon height={12} width={12} />
        ) : (
          <EyeShowIcon height={12} width={12} />
        )}
      </Button>
      {isTextVisible ? (
        <TextContainer>
          <Text size="normal" color="primaryText">
            {safeText}
          </Text>
        </TextContainer>
      ) : (
        <MaskContainer>
          <MaskedText>{text}</MaskedText>
        </MaskContainer>
      )}
    </Box>
  );
};

export default MaskVisibility;
